import { render, staticRenderFns } from "./SeferMaliyetRaporuView.vue?vue&type=template&id=48ad162c&scoped=true&"
import script from "./SeferMaliyetRaporuView.vue?vue&type=script&lang=js&"
export * from "./SeferMaliyetRaporuView.vue?vue&type=script&lang=js&"
import style0 from "./SeferMaliyetRaporuView.vue?vue&type=style&index=0&id=48ad162c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ad162c",
  null
  
)

export default component.exports